module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA4ElEQVR4Ac2RQ4MCUBCA+7eL63rva9u2bdvKNje7nmqOuS7he8aYUxAiOVNIgQOzb/7PNvXr4tu97++fMzMzs7Oz76+vSCRBk+v+hb3w/lmcwDzPDjOhZPjhYW+jDfZA80jn2WA3RiHYBxZ24wQmvp2IIGQZ6L15mhuvD1qXd/+Pq5sb77o6+tXzIBOeXIsT+PSg2U/J9c+8KxQyGvVTo+WVs406vQ67XPfdHaahefrxnRg0ppg6FhnxMvTvt2/uGs7MAbsfB1cMJ2AhdZZYUAgy0GEj86pABjpsCl+HEiMK4XCnrsn2RgcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_olympics.png
// module id = 1319
// module chunks = 0